import React from 'react';
import { Box, CircularProgress } from '@mui/material';

interface ApprovalLoadingStateProps {
  message?: string;
}

const ApprovalLoadingState: React.FC<ApprovalLoadingStateProps> = ({ message = 'Loading…' }) => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <Box textAlign="center">
      <CircularProgress size={40} sx={{ color: '#3b82f6' }} />
      <Box mt={2} color="#64748b">
        {message}
      </Box>
    </Box>
  </Box>
);

export default ApprovalLoadingState;
